// @ts-nocheck



import type RequestsController from '../requests';
import type { WialonApiSection } from '../requests';

export class Render {
  controller: WialonApiSection;

  constructor(controller: RequestsController) {
    this.controller = controller.getApiSection('render');
  }

  /**
   * Создает графический слой, основанный на координатах из сообщений
   * @param params Параметры
   */
  async createMessagesLayer(params)
























  {
    const defaultParams = {
      arrows: 1,
      tripDetector: 1,
      points: 1,
      annotations: 1,
      trackColor: 'red',
      pointColor: 'blue'
    };
    return await this.controller.fetch('create_messages_layer', {
      ...defaultParams,
      ...params
    });
  }
}
